<template>
        <TextArea
                :value="singleValue"
                @input="emitSingleValue($event)"
        ></TextArea>
</template>

<script>
  import TextArea from "./components/TextArea";
  import responseMixin from "./responseMixin";
  export default {
    name: "TextResponse",
    mixins: [responseMixin],
    components:{
            TextArea
    },
    computed: {

    }
  }
</script>

<style scoped>

</style>